class ShadeFinderQuizStart extends window.BAO.CustomElement() {
  connectedCallback () {
    this.setupListeners()
  }

  setupListeners () {
    const startSectionEl = document.querySelector('shade-finder-quiz-start')
    const startQuizBtn = document.querySelector('[data-start-shadefinder-quiz-trigger]')

    startQuizBtn.addEventListener('click', () => {
      startSectionEl.classList.remove('is-active')

      const skintoneSectionEl = document.querySelector('shade-finder-quiz-skintone')

      skintoneSectionEl.classList.add('is-active')
    })
  }
}

if (!customElements.get('shade-finder-quiz-start')) {
  customElements.define('shade-finder-quiz-start', ShadeFinderQuizStart)
}
